import React, { FC } from 'react'

import { WarningModal } from 'components/WarningModal'

type WarningProps = {
  downloadAction: () => void
  skipAction: () => void
  text?: string
}

export const ProjectStatusWarningModal: FC<WarningProps> = ({
  downloadAction,
  skipAction,
  text
}) => {
  const buttonProps = [
    { text: 'Skip', action: skipAction},
    { text: 'Download', action: downloadAction },
  ]

  const warningText = 'Do you want to download the Folders, Templates and other documents presents inside Folder?'

  return (
    <WarningModal
      warningText={warningText}
      modalButtonProps={buttonProps}
      // onSelection={skipAction}
    />
  )
}
